import { MessageSquare, Share2, ShoppingBag, Briefcase, Building2, Wallet, Bell, Sparkles } from 'lucide-react';
import { motion } from 'motion/react';
import MarketingLayout from './_layout';
import { cn } from '../../utils/helpers';

const features = [
  { title: 'Social Connect', desc: 'Build your network and share insights with a global community of professionals.', icon: Share2, color: 'text-blue-600 dark:text-blue-400', bg: 'bg-blue-50 dark:bg-blue-950/40' },
  { title: 'Smart Commerce', desc: 'A curated marketplace to buy and sell products within the Messego network.', icon: ShoppingBag, color: 'text-emerald-600 dark:text-emerald-400', bg: 'bg-emerald-50 dark:bg-emerald-950/40' },
  { title: 'Career Hub', desc: 'Find your next opportunity or hire top talent with our integrated job board.', icon: Briefcase, color: 'text-amber-600 dark:text-amber-400', bg: 'bg-amber-50 dark:bg-amber-950/40' },
  { title: 'Business Intelligence', desc: 'Deep analytics and market insights to help your company grow faster.', icon: Building2, color: 'text-purple-600 dark:text-purple-400', bg: 'bg-purple-50 dark:bg-purple-950/40' },
  { title: 'Unified Messaging', desc: 'Seamless communication across all modules, from team chats to customer support.', icon: MessageSquare, color: 'text-rose-600 dark:text-rose-400', bg: 'bg-rose-50 dark:bg-rose-950/40' },
  { title: 'Secure Wallet', desc: 'Manage finances, payments, and assets with enterprise-grade security.', icon: Wallet, color: 'text-neutral-900 dark:text-neutral-50', bg: 'bg-neutral-100 dark:bg-neutral-800' },
  { title: 'Real-Time Alerts', desc: 'Stay informed with intelligent notifications across messaging, payments, and orders.', icon: Bell, color: 'text-sky-600', bg: 'bg-sky-50' },
  { title: 'AI Assistants', desc: 'Built-in copilots that draft messages, summarize threads, and suggest next steps.', icon: Sparkles, color: 'text-indigo-600', bg: 'bg-indigo-50' },
];

export default function FeaturesPage() {
  return (
    <MarketingLayout
      title="A unified ecosystem"
      subtitle="Stop switching between dozens of apps. Messego brings your professional life together in one product."
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {features.map((f, i) => (
          <motion.div
            key={f.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.05 }}
            className="bg-white dark:bg-neutral-900 p-6 rounded-[2rem] border border-neutral-200 dark:border-neutral-800 flex gap-5"
          >
            <div className={cn('flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center', f.bg, f.color)}>
              <f.icon className="w-6 h-6" />
            </div>
            <div className="space-y-1">
              <h3 className="font-bold text-neutral-900 dark:text-neutral-50">{f.title}</h3>
              <p className="text-sm text-neutral-500 dark:text-neutral-400 leading-relaxed">{f.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </MarketingLayout>
  );
}
